/**
 * Điểm vào i18n — export bản dịch tiếng Việt và helper thay placeholder.
 */
import { vi } from './vi';

export const TEXT = vi;

/** Thay {key} trong template bằng giá trị tương ứng. */
export const formatText = (template, params = {}) =>
  Object.entries(params).reduce(
    (result, [key, value]) => result.replace(new RegExp(`\\{${key}\\}`, 'g'), value),
    template
  );

export default TEXT;
